import React from 'react';
import { FormatDate } from 'components/dates/FormatDate';
import stripHtml from '../Inputs/TextAreaQuill/stripHtml';
import { Link } from 'react-router-dom';
import { NDivider } from '@innersource-nn/novoui-react';

interface CardProps {
    label: string;
    uri: string;
    type: string;
    body?: React.ReactNode;
    description: string;
    updated?: string;
    actions?: React.ReactNode;
    subheader?: string;
    tags?: string[];
    onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

const Card = ({
    label,
    uri,
    type,
    body,
    description,
    updated,
    actions,
    subheader,
    tags,
    onClick,
}: CardProps) => {
    return (
        <Link
            onClick={onClick}
            to={uri}
            className="transition-all duration-500 bg-white z-0 hover:z-10 text-sm shadow-md flex flex-col space-y-8 text-true-blue p-16 rounded-8 cursor-pointer focus:ring focus:ring-light-blue-400 hover:shadow-lg group relative hover:overflow-auto"
        >
            <div className="h-[6rem]">
                <div className="flex gap-8 max-h-14">
                    <h2 className="font-bold text-lg  break-words	overflow-hidden">
                        {label}
                    </h2>
                </div>
                <p>{subheader}</p>
                <p className="text-faded-blue-600 text-sm font-extralight h-40 text-clip overflow-hidden ">
                    {description === '' ? (
                        <i>This {type} does not have a description</i>
                    ) : (
                        stripHtml(description)
                    )}
                </p>
            </div>
            {body}
            {tags && (
                <div className="flex gap-4 mt-8 min-h-20">
                    {tags?.map((tag, index) => {
                        return (
                            <div
                                className="text-xs bg-light-blue-200 text-true-blue px-12 py-4 rounded-28"
                                key={`card-tag-${index}`}
                            >
                                {tag}
                            </div>
                        );
                    })}
                </div>
            )}
            <NDivider orientation="horizontal" />
            {updated && (
                <div className="flex-grow mt-16">
                    <p className="mt-auto">
                        Latest update: {FormatDate(updated)}
                    </p>
                </div>
            )}
            {actions}
        </Link>
    );
};

export default Card;
